import React from "react";
import { useContext } from "react";
import { MdOutlineClose } from "react-icons/md";
import { TbShoppingBagX } from "react-icons/tb";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "config";
import { CartContext } from "context/CartContext";
import { priceComma } from "utils/priceComma";
import { useTranslation } from "react-i18next";
import { FavoriteContext } from "context/FavoriteContext";
import { FaTimes } from "react-icons/fa";

const FavoriteModal = ({ setModal }) => {
  const { favorite, setfavorite } = useContext(FavoriteContext);

  const [t] = useTranslation("global");

  function handleDelete(e) {
    e.preventDefault();
    const newCart = favorite.filter((c) => c.id !== e.id);

    setfavorite(newCart);
  }

  return (
    <div className="w-full relative flex flex-col items-center justify-between ">
      <div className="flex justify-between w-full items-center border-b py-3 px-3 mb-6">
        <button
          onClick={() => {
            setModal(false);
          }}
          className="flex items-center "
        >
          <MdOutlineClose size={25} />
        </button>
        <span className="text-xl ">{t("favorites")}</span>
      </div>
      {favorite.length ? (
        <div className="flex flex-col w-full">
          {favorite.map((e) => (
            <Link
              dir="rtl"
              to={"/product/" + e.url}
              className="flex relative w-full gap-3 justify-start items-center border-b p-3"
            >
              <img className="w-[70px]" src={CDN_BASE_URL + e.cover} alt="" />
              <div className="flex flex-col text-[14px]">
                <span className="text-[12px]"> {e?.subCategory?.name}</span>
                <span className="font-bold">{e.name}</span>

                <span>
                  {priceComma(e.minPrice, 2)}
                  {t("toman")}
                </span>
              </div>
              <button
                onClick={(e) => handleDelete(e)}
                className="absolute top-1 left-1"
              >
                <MdOutlineClose size={20} color={"#999"} />
              </button>
            </Link>
          ))}
        </div>
      ) : (
        <>
          <FaTimes size={130} color={"#8f8f8f"} />
          <p>{t("favorite-is-empty")}</p>
        </>
      )}
    </div>
  );
};

export default FavoriteModal;
